var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"modal",attrs:{"centered":"","scrollable":"","no-stacking":"","hide-footer":"","size":"xl","no-close-on-backdrop":"","title":"File Status"}},[_c('noti-table',{attrs:{"items":_vm.tableData,"total":_vm.total,"header":_vm.header,"hidePagination":true},scopedSlots:_vm._u([{key:"status",fn:function({ item }){return [_c('b-badge',{class:{
        'bg-success': item.status === 'Success',
        'bg-danger': item.status === 'Failed',
        'bg-warning': item.status === 'In Progress'
      }},[_vm._v(" "+_vm._s(item.status)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }